class KlaviyoForm extends HTMLElement {
  constructor () {
    super()

    this.form = this.querySelector('form')
    this.errorElement = this.querySelector('[data-signup-error]')
    this.successElement = this.querySelector('[data-signup-success]')
    this.emailInput = this.querySelector('input[type="email"]')
    this.phoneInput = this.querySelector('input[type="tel"]')
    this.listId = this.getAttribute('data-list-id')
    this.errorMessageDefault = this.getAttribute('data-error-message') || 'An error occurred. Please try again.'
  }

  connectedCallback () {
    if (!this.form) {
      console.error('KlaviyoForm: No form element found within the component.')
      return
    }
    if (!this.errorElement) {
      console.warn('KlaviyoForm: No error element found with [data-signup-error].')
    }
    if (!this.successElement) {
      console.warn('KlaviyoForm: No success element found with [data-signup-success].')
    }
    if (!this.listId) {
      console.error('KlaviyoForm: Missing data-list-id attribute.')
      return
    }

    this.form.addEventListener('submit', this.handleSubmit.bind(this))
  }

  async handleSubmit (event) {
    event.preventDefault()

    if (this.errorElement) this.errorElement.classList.add('hidden')
    if (this.successElement) this.successElement.classList.add('hidden')
    this.form.classList.remove('hidden')

    const email = this.emailInput?.value || null
    const phone = this.phoneInput?.value || null

    if (!email && !phone) {
      if (this.errorElement) {
        this.errorElement.textContent = 'Please enter an email or phone number.'
        this.errorElement.classList.remove('hidden')
      }
      return
    }

    try {
      const formData = new URLSearchParams()
      formData.append('g', this.listId)
      if (email) formData.append('email', email)
      if (phone) formData.append('phone_number', phone)

      const response = await fetch('https://manage.kmail-lists.com/ajax/subscriptions/subscribe', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'Cache-Control': 'no-cache',
        },
        body: formData,
      })

      const responseText = await response.text()
      const responseData = JSON.parse(responseText)

      if (responseData.success) {
        if (this.emailInput) this.emailInput.value = ''
        if (this.phoneInput) this.phoneInput.value = ''
        this.form.classList.add('hidden')
        if (this.successElement) this.successElement.classList.remove('hidden')
      } else {
        const apiErrorMessage = responseData.errors && responseData.errors.length > 0
          ? responseData.errors[0]
          : this.errorMessageDefault
        if (this.errorElement) {
          this.errorElement.textContent = apiErrorMessage
          this.errorElement.classList.remove('hidden')
        }
        if (this.successElement) this.successElement.classList.add('hidden')
      }
    } catch (error) {
      console.error('Error submitting Klaviyo form:', error)
      if (this.errorElement) {
        this.errorElement.textContent = this.errorMessageDefault
        this.errorElement.classList.remove('hidden')
      }
      if (this.successElement) this.successElement.classList.add('hidden')
    }
  }
}

customElements.define('klaviyo-form', KlaviyoForm)
